<script lang="ts">
	import PosterTile from './PosterTile.svelte'
	import bv from 'shared/object/body_validator'

	export let posters
	export let desktop_columns: number = 2
	export let desktop_aspect_ratio: string = `16:9`
	export let mobile_columns: number = 1
	export let mobile_aspect_ratio: string = `3:1`
	export let desktop_font_size: string = `3rem`
	export let mobile_font_size: string = `2.5rem`
	export let justify_content: string = `space-evenly`
	export let gap: string = `1rem`

	const poster_validator = bv.array(bv.object({
		href: bv.string,
		name: bv.string,
		hide_name: bv.optional(bv.boolean),
		thumbnail_url: bv.optional(bv.string),
		desktop_image_src: bv.optional(bv.string),
		mobile_image_src: bv.optional(bv.string),
		mux_playback_id: bv.optional(bv.string),
		thumbnail_timecode_seconds: bv.optional(bv.number),
		new: bv.optional(bv.boolean),
	}))

	let errors: string[] = []

	let desktop_padding_bottom: string
	let mobile_padding_bottom: string

	// barnacle initialization should always attempt converting data attributes to JSON.  if it's not an object, it's probably not valid JSON
	if (typeof posters === `string`) {
		try {
			posters = JSON.parse(posters)
		} catch (e: any) {
			console.error(e)
			errors = [ e.toString() ]
		}
	}

	if (!poster_validator.is_valid(posters)) {
		errors.push(...poster_validator.get_messages(posters, `posters`))
	}

	if (!desktop_aspect_ratio.match(/^\d+:\d+$/)) {
		errors.push(`desktop_aspect_ratio must be in the format "width:height"`)
	} else if (!mobile_aspect_ratio.match(/^\d+:\d+$/)) {
		errors.push(`mobile_aspect_ratio must be in the format "width:height"`)
	} else {
		const [ desktop_width, desktop_height ] = desktop_aspect_ratio.split(`:`)
		desktop_padding_bottom = Number(desktop_height) / Number(desktop_width) * 100 + `%`

		const [ mobile_width, mobile_height ] = mobile_aspect_ratio.split(`:`)
		mobile_padding_bottom = Number(mobile_height) / Number(mobile_width) * 100 + `%`
	}
</script>

{#each errors as error}
	<p class=error>{error}</p>
{/each}

{#if poster_validator.is_valid(posters)}
	<div class="posters" style="
		--desktop-columns: { desktop_columns };
		--mobile-columns: { mobile_columns };
		--desktop-padding-bottom: { desktop_padding_bottom };
		--mobile-padding-bottom: { mobile_padding_bottom };
		--desktop-font-size: { desktop_font_size };
		--mobile-font-size: { mobile_font_size };
		--justify-content: { justify_content };
		--gap: { gap };
	">
		{#each posters as poster}
			<PosterTile {poster} />
		{/each}
	</div>
{/if}

<style>
	.error {
		color: red;
	}
	.posters {
		display: flex;
		flex-wrap: wrap;
		justify-content: --var(--justify-content);
		gap: var(--gap);
	}

	.posters :global(.poster-tile) {
		flex-basis: calc(calc(100% / var(--desktop-columns)) - calc(var(--gap) - calc(var(--gap) / var(--desktop-columns))));
	}

	@media (max-width: 800px) {
		.posters :global(.poster-tile) {
			flex-basis: calc(calc(100% / var(--mobile-columns)) - calc(var(--gap) - calc(var(--gap) / var(--mobile-columns))));
		}
	}
</style>
